/* 
  File: C:\Users\Markus Diehl\source\Expert4Germany\src\pages\legal\AGB.js
  Name: AGB.js
  Zweck: Allgemeine Geschäftsbedingungen.
*/

import React from 'react';

const AGB = () => {
  return (
    <div className="p-5 text-white bg-gray-900 min-h-screen">
      <h1 className="text-3xl font-bold mb-4">AGB</h1>
      <p>Hier stehen die Allgemeinen Geschäftsbedingungen. (Inhalt folgt.)</p>
    </div>
  );
};

export default AGB;
